import axiosInstance from '../axios/axiosInstance';
import { ExamPart } from '../model/response';

export const findAllExamPartsByExamId = async (examId: string) => {
  const { data } = await axiosInstance.get<ExamPart[]>('exam-parts', { params: { examId, fromCMS: true } });
  return data;
};
